module.exports = __webpack_public_path__ + "img/oem2.bc444cbe.png";